import styles from "./UsualText.module.scss"

export const UsualText = ({ children, bold }) => {
    return <div className={styles.text} style={{ fontWeight: bold ? 600 : null }}>{children}</div >
}